import React from 'react';
import 'antd/dist/reset.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import '@fontsource/poppins';
import { NextUIProvider } from '@nextui-org/react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');

const root = createRoot(rootElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NextUIProvider>
          <App className="dark text-foreground bg-background" />
        </NextUIProvider>
      </PersistGate>
    </Provider>
    ,
  </QueryClientProvider>
);
